
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M14 9.61V7H16C17.1 7 18 6.1 18 5C18 3.9 17.1 3 16 3H13C12.45 3 12 3.45 12 4V7.61L14 9.61ZM5.11998 3.56C4.72998 3.17 4.09998 3.17 3.70998 3.56C3.31998 3.95 3.31998 4.58 3.70998 4.97L12 13.27V13.55C11.06 13.01 9.89998 12.8 8.66998 13.23C7.32998 13.71 6.29998 14.9 6.05998 16.3C5.59998 19.04 7.91998 21.38 10.65 20.95C12.61 20.64 14 18.84 14 16.85V15.27L19.02 20.29C19.41 20.68 20.04 20.68 20.43 20.29C20.82 19.9 20.82 19.27 20.43 18.88L5.11998 3.56Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-music-off`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconMusicOff

    ```js
    <b-new-b-icon-music-off />
    ```
</docs>


